import { ChevronDown, Languages } from "lucide-react";
import {
  SITE_LANGUAGES,
  useSiteLanguage,
} from "@/features/preferences/SiteLanguageContext";
import "./LanguageSelector.css";

export function LanguageSelector({ label, onLanguageChange }) {
  const { language, setLanguage } = useSiteLanguage();

  const changeLanguage = (event) => {
    const nextLanguage = event.target.value;
    setLanguage(nextLanguage);
    onLanguageChange?.(nextLanguage);
  };

  return (
    <label className="kavia-language-selector" data-language={language} title={label}>
      <Languages className="kavia-language-selector__icon" size={16} strokeWidth={1.8} aria-hidden="true" />
      <span className="kavia-language-selector__sr-only">{label}</span>
      <span className="kavia-language-selector__short" aria-hidden="true">{language.toUpperCase()}</span>
      <select
        aria-label={label}
        value={language}
        onChange={changeLanguage}
      >
        {SITE_LANGUAGES.map(({ value, label: optionLabel }) => (
          <option lang={value} value={value} key={value}>{optionLabel}</option>
        ))}
      </select>
      <ChevronDown className="kavia-language-selector__chevron" size={14} strokeWidth={2} aria-hidden="true" />
    </label>
  );
}
